import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@speedoc/design-assets";
import { Close, Star } from "@speedoc/design-assets/build/icons/index";
import useAppDownloadLink from "../../hooks/useAppDownloadLink";
import { useMediaQuery } from "react-responsive";
import { GlobalStore } from "../../stores/global";

const MobileModal = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 576px)" });
  const structure = GlobalStore.useState(c => c.structure);
  const downloadLink = useAppDownloadLink();
  const [isShowing, setIsShowing] = useState(true);

  const buildStars = stars => Array.from({ length: stars }, (e, i) => <Star key={i} />);

  const content = structure?.mobileModal;

  if (content === undefined) return null;

  return (
    isShowing &&
    isMobile && (
      <div id="mobileModal">
        <div className="close" onClick={e => setIsShowing(false)}>
          <Close />
        </div>
        <div className="logo">
          <Link to="/">
            <img alt="test" src={content.image?.url} />
          </Link>
        </div>
        <div className="text">
          <div className="title">{content.title}</div>
          <div className="rating">{buildStars(content.stars)}</div>
        </div>
        <a className="button secondary sm" href={downloadLink}>
          <Button className="primary">
            <span>{content.button}</span>
          </Button>
        </a>
      </div>
    )
  );
};

const MobileModalV4 = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 576px)" });
  const structure = GlobalStore.useState(c => c.structure);
  const [isShowing] = useState(true);

  const content = structure?.mobileModal;
  if (content === undefined) return null;

  return isShowing && isMobile && <div id="mobileModal" className="mobileModalV4" />;
};

let temp = process.env.REACT_APP_V4_ENABLE === "true" ? MobileModalV4 : MobileModal;
export default temp;
